import {
  SearchSortDirection,
  SearchSortField,
} from '@hooks/useSearchedAlbums/types';
import {
  DEFAULT_LIMIT,
  DEFAULT_PAGE,
  SEARCH_SORT_DIRECTION_DESC,
} from '@helpers/constants';
import { isEmptyString } from '@helpers/utils';
import { URLEncodedSearchParams } from './types';

export function queryStateFromSearchParams(
  params: Record<string, string | string[] | undefined>,
): URLEncodedSearchParams {
  const feedStateFromQueryParams =
    typeof params.feeds === 'string' && !isEmptyString(params.feeds)
      ? params.feeds.split(',').map(decodeURIComponent)
      : [];

  const licensorStateFromQueryParams =
    typeof params.licensors === 'string' && !isEmptyString(params.licensors)
      ? params.licensors.split(',').map(decodeURIComponent)
      : [];

  const searchStateFromQueryParams =
    typeof params.q === 'string' && !isEmptyString(params.q)
      ? params.q.split(',').map(decodeURIComponent)
      : [];

  const limitStateFromQueryParams =
    typeof params.limit === 'string' && !isEmptyString(params.limit)
      ? decodeURIComponent(params.limit)
      : DEFAULT_LIMIT;

  const pageStateFromQueryParams =
    typeof params.page === 'string' && !isEmptyString(params.page)
      ? decodeURIComponent(params.page)
      : DEFAULT_PAGE;

  const searchSortFieldFromQueryParams: SearchSortField =
    typeof params.searchSortField === 'string' &&
    !isEmptyString(params.searchSortField)
      ? (decodeURIComponent(params.searchSortField) as SearchSortField)
      : 'ORIGINAL_RELEASE_DATE';

  const searchSortDirectionFromQueryParams: SearchSortDirection =
    typeof params.searchSortDirection === 'string' &&
    !isEmptyString(params.searchSortDirection)
      ? (decodeURIComponent(params.searchSortDirection) as SearchSortDirection)
      : SEARCH_SORT_DIRECTION_DESC;

  return {
    feedStateFromQueryParams,
    licensorStateFromQueryParams,
    searchStateFromQueryParams,
    limitStateFromQueryParams,
    pageStateFromQueryParams,
    searchSortFieldFromQueryParams,
    searchSortDirectionFromQueryParams,
  };
}
